<template>
    <div class="modules-show-tools">
        <div class="modules-search">
            <b-input-group>
                <b-form-input
                    class="apprentice-input-field"
                    v-model="searchFilter"
                    size="md"
                    :placeholder="$t('modules.search')"
                    @input="updateTerm"></b-form-input>
                <b-input-group-append>
                    <span class="btn-search icon"> </span>
                </b-input-group-append>
            </b-input-group>
        </div>

        <div class="modules-sorting">
            <label for="modules-sorting-options">{{ $t('modules.search_by') }}:</label>
            <b-form-select
                class="apprentice-primary-select"
                id="modules-sorting-options"
                v-model="selected"
                :options="options"
                @change="updateSorting">
            </b-form-select>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-module-show-tools-component',
    data() {
        return {
            searchFilter: '',
            options: [
                {
                    value: 1,
                    text: this.$t('common.title'),
                },
                {
                    value: 2,
                    text: this.$t('modules.last_added'),
                },
                {
                    value: 3,
                    text: this.$t('modules.register_date'),
                },
            ],
            selected: 1,
        };
    },

    methods: {
        updateTerm(value) {
            this.$emit('update-search-term', value);
        },

        updateSorting(value) {
            this.$emit('update-sorting', value);
        },
    },
};
</script>

<style scoped lang="scss">
.modules-show-tools {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');

    .apprentice-primary-select,
    .form-control {
        margin-bottom: map-get($grid-gutter-spacing, 'ten');
    }
}

.modules-search {
    margin-bottom: map-get($grid-gutter-spacing, 'ten');

    .apprentice-input-field {
        margin-bottom: 0;
    }

    input {
        &:focus,
        &:focus-visible {
            box-shadow: none;
            outline: none;
        }
    }

    .input-group-append {
        color: $primary;
        align-items: center;
        background-color: $secondary-background-color;
        padding: map-get($grid-gutter-spacing, 'fifteen') map-get($grid-gutter-spacing, 'ten');
        border-top-right-radius: $border-radius-content;
        border-bottom-right-radius: $border-radius-content;
    }

    &:focus-within {
        border-radius: $border-radius-content;
        box-shadow: 0 0 0 0.2rem rgba($primary, 0.25);
    }
}

.modules-sorting {
    label {
        margin-right: map-get($grid-gutter-spacing, 'eight');
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .modules-show-tools {
        display: flex;
        flex-direction: column;
    }
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .modules-show-tools {
        flex-direction: row;
        justify-content: space-between;
    }

    .modules-search {
        margin-bottom: 0;
    }

    .modules-show-tools {
        .apprentice-primary-select,
        .form-control {
            margin-bottom: 0;
        }
    }

    .modules-sorting {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-left: $grid-gutter-width;

        label {
            flex: 0 0 auto;
        }

        select {
            flex: initial;
        }
    }
}
</style>
